// src/Components/BattlezoneData.js

const battlezoneMatches = [
  {
    id: 'roman_vs_rock90s',
    title: 'Who Wins?: 2021 Roman Reigns vs 90s ROCK',
    optionA: 'Roman Reigns',
    optionB: 'Rock',
    imgA: '/images/RR.jpg',
    imgB: '/images/ROCK.jpg'
  },
    {
      id: 'Orton_vs_SCSA',
      title: 'More Dangerous: 2009 Randy Orton vs 90s Stone Cold',
      optionA: 'Randy Orton',
      optionB: 'Stone Cold',
      imgA: '/images/O.jpg', // make sure this image exists in public/images
      imgB: '/images/S.jpg'
    },
    {
      id: 'kurt_vs_seth',
      title: '2001 Kurt Angle vs 2015 Seth Rollins',
      optionA: 'Kurt Angle',
      optionB: 'Seth Rollins',
      imgA: '/images/K.webp',
      imgB: '/images/RO.webp'
    },
    {
      id: 'punk_vs_rock',
      title: 'Better Promos: 2011 CM Punk vs 2001 ROCK',
      optionA: 'CM Punk',
      optionB: 'Rock',
      imgA: '/images/P.jpg',
      imgB: '/images/ROCK.jpg'
    },
    
        {
          id: 'bret_vs_aj',
          title: 'Better Promos: 1997 Bret Hart vs 2016 AJ Styles',
          optionA: 'Bret Hart',
          optionB: 'AJ Styles',
          imgA: '/images/B.avif',
          imgB: '/images/A.jpg'
        },
        {
          id: 'cena_vs_y2j',
          title: 'Better Promos: 2005 John Cena vs 2008 Y2J',
          optionA: 'John Cena',
          optionB: 'Chris Jericho',
          imgA: '/images/J.avif',
          imgB: '/images/C.jpg'
        },
        
        {
          id: 'roman_vs_edge',
          title: 'Better Promos: 2021 Roman Reigns vs 2008 Edge',
          optionA: 'Roman Reigns',
          optionB: 'Edge',
          imgA: '/images/REIGNS.webp',
          imgB: '/images/E.jpg'
        },
        {
          id: 'hhh_vs_drew',
          title: ': 1999 Triple H vs 2020 Drew McIntyre',
          optionA: 'Triple H',
          optionB: 'Drew McIntyre',
          imgA: '/images/T.jpg',
          imgB: '/images/D.jpg'
        },
        {
          id: 'bryan_vs_bret',
          title: 'Better Technician: 2014 Daniel Bryan vs 1997 Bret Hart',
          optionA: 'Daniel Bryan',
          optionB: 'Bret Hart',
          imgA: '/images/DB.avif',
          imgB: '/images/B.avif'
        },
        {
          id: 'cena_vs_austin',
          title: 'Better Face: 2006 John Cena vs 1998 Stone Cold Steve Austin',
          optionA: 'John Cena',
          optionB: 'Stone Cold',
          imgA: '/images/J.avif',
          imgB: '/images/S.jpg'
        },
        {
          id: 'brock_vs_gunther',
          title: 'Monster?: 2002 Brock Lesnar vs 2023 Gunther',
          optionA: 'Brock Lesnar',
          optionB: 'Gunther',
          imgA: '/images/BL.webp',
          imgB: '/images/G.webp'
        },
      
      
  ];
  
  export default battlezoneMatches;
  